import apiSlice from "./apiSlice";
const workflowApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getAllWorkflow: builder.query({
            query: (req) => ({
                url: `WorkflowApproval`,
                params: req,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["AllWorkflow"],
        }),
        getEntityCategoryList: builder.query({
            query: (req) => ({
                url: `Settings?name=EntityName`,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
        }),
        addWorkflow: builder.mutation({
            query: (body) => ({
                url: `WorkflowApproval`,
                method: 'POST',
                body,
            }),
            invalidatesTags: ['AllWorkflow']
        }),
        editWorkflow: builder.mutation({
            query: (body) => ({
                url: `WorkflowApproval`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: ['AllWorkflow']
        }),
        getHistory: builder.query({
            query: (req) => ({
                url: `Workflow/history`,
                params: req,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true
        }),
    }),
});

export const {
    useGetAllWorkflowQuery,
    useGetEntityCategoryListQuery,
    useAddWorkflowMutation, useEditWorkflowMutation, useGetHistoryQuery
} = workflowApiSlice;
